<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <div slot="header">
          <b-row>
            <b-col cols="6">
              <span>{{ 'invoices_update_title' | translate('global') }}</span>
            </b-col>
          </b-row>
        </div>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-card border-variant="success" bg-variant="light" class="text-center">
            <blockquote class="card-blockquote">
              <table class="table table-sm center">
                <thead>
                <tr>
                  <th class="no-border-top">{{ 'user' | translate('global') }}</th>
                  <th class="no-border-top">{{ 'ax_po_number' | translate('global') }}</th>
                  <th class="no-border-top">{{ 'invoice_created_at' | translate('global') }}</th>
                  <th class="no-border-top">{{ 'status' | translate('global') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="border-r-3">{{ info.user }}</td>
                  <td class="border-r-3">{{ info.ax_po_number ? info.ax_po_number : '-'}}</td>
                  <td class="border-r-3">{{ info.created_at }}</td>
                  <td class="border-r-3">{{ info.status }}</td>
                </tr>
                </tbody>
              </table>
            </blockquote>
          </b-card>

          <b-row>
            <b-col cols="12">
              <b-nav tabs>
                <b-nav-item :to="{ name: 'InvoiceUpdate', params: { id: $route.params.id, tab: 'invoice' }}"
                            :active="activeTab === 'invoice'">
                  {{ 'invoice_tab' | translate('global') }}
                </b-nav-item>
                <b-nav-item :to="{ name: 'InvoiceUpdate', params: { id: $route.params.id, tab: 'bookkeeper' }}"
                            :active="activeTab === 'purchase-order'">
                  {{ 'invoice_bookkeeper_tab' | translate('global') }}
                </b-nav-item>
                <b-nav-item :to="{ name: 'InvoiceUpdate', params: { id: $route.params.id, tab: 'history' }}"
                            :active="activeTab === 'history'">
                  {{ 'history_tab' | translate('global') }}
                </b-nav-item>
              </b-nav>

              <div class="tab-content">
                <Invoice v-if="activeTab === 'invoice'" @getData="getData"/>
                <Bookkeeper v-if="activeTab === 'bookkeeper'" @getData="getData"/>
                <History v-if="activeTab === 'history'" :page="page"/>
              </div>
            </b-col>
          </b-row>
        </div>
        <div slot="footer" class="flex-container">
          <b-button :to="{ name: 'Invoices' }" type="reset" variant="secondary" class="ml-2">
            {{ 'back_to_list' | translate('global') }}
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import statuses from '@/store/statuses';
import VuexTypes from '@/store/types/index';
import Invoice from './Tabs/Invoice.vue';
import Bookkeeper from './Tabs/Bookkeeper/Bookkeeper.vue';
import History from './Tabs/History.vue';

const InvoiceTypes = VuexTypes.invoices;

export default {
  mounted() {
    this.getData();
    if (typeof (this.$route.params.tab) === 'undefined') {
      this.$router.push({ name: 'InvoiceUpdate', params: { id: this.$route.params.id, tab: 'invoice' } });
    }
  },
  props: ['tab', 'page'],
  data() {
    return {
      spinners: {
        contentIsLoading: false,
      },
      activeTab: this.$route.params.tab,
      info: {},
    };
  },
  components: { Invoice, Bookkeeper, History },
  computed: {
    ...mapGetters('Invoices', [
      'invoiceUpdateData',
      'invoicePaymentReject',
      'invoiceUpdateDetainedPayment'
    ]),
  },
  watch: {
    '$route'(to, from) {
      this.changeTab();

      if (from.params.id !== to.params.id) {
        this.getData();
      }
    },
    invoiceUpdateData: {
      handler: function () {
        if (this.invoiceUpdateData.status === statuses.LOADED) {
          this.spinners.contentIsLoading = false;
          this.fillData();
        }
      },
      deep: true
    },
    invoicePaymentReject: {
      handler: function () {
        if (this.invoicePaymentReject.status === statuses.LOADED) {
          if (!this.invoicePaymentReject.data['ax_import_error']) {
            this.getData();
          }
        }
      },
      deep: true
    },
    invoiceUpdateDetainedPayment: {
      handler: function () {
        if (this.invoiceUpdateDetainedPayment.status === statuses.LOADED) {
          this.getData();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Invoices', [
      InvoiceTypes.INVOICE_UPDATE_DATA,
      InvoiceTypes.INVOICE_CLASSIFIERS,
    ]),
    getData() {
      this.INVOICE_UPDATE_DATA(this.$route.params.id);
      this.INVOICE_CLASSIFIERS();
    },
    fillData() {
      const invoice = this.invoiceUpdateData.data.invoice;
      this.info = {
        user: invoice['user'] ? invoice['user']['full_name'] : '',
        ax_po_number: invoice['ax_po_number'],
        status: this.$t(invoice['status'], 'statuses'),
        created_at: invoice['created_at']
      };
    },
    changeTab() {
      const tab = this.tab;
      if (tab === 'invoice' || tab === 'bookkeeper' || tab === 'history') {
        this.activeTab = tab;
      } else {
        this.$router.push({ name: 'InvoiceUpdate', params: { id: this.$route.params.id, tab: 'invoice' } });
      }
    },
  }
};

</script>

<style scoped>
</style>
